import Forum from './ForumApplication';

const app = new Forum();

// @ts-ignore
window.app = app;

export default app;
